var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H32C36.4183 0 40 3.58172 40 8V32C40 36.4183 36.4183 40 32 40H8C3.58172 40 0 36.4183 0 32V8Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.79808 39.9975C3.47311 39.8904 0 36.3508 0 32V25.247L7.99775 18.2075C9.82775 16.5975 12.2778 16.5975 14.1078 18.2075L21.7378 24.9275C23.5678 26.5375 26.0177 26.5375 27.8477 24.9275L31.0277 22.1275H31.0477C32.8778 20.5175 35.3277 20.5175 37.1577 22.1275L40 24.6304V32C40 36.3508 36.5269 39.8904 32.2019 39.9975H7.79808Z",
    fill: "#C4C4C4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6877 10C36.6877 12.2091 34.8969 14 32.6877 14C30.4786 14 28.6877 12.2091 28.6877 10C28.6877 7.79086 30.4786 6 32.6877 6C34.8969 6 36.6877 7.79086 36.6877 10Z",
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImg);
export default __webpack_public_path__ + "static/media/no-img.b5d5475679bf574c4b2f3b463efb7fc5.svg";
export { ForwardRef as ReactComponent };